export default __webpack_public_path__ + "static/media/clip.6c57f219.mp4";